import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import { INIT } from './types';

export const initApp =
    (promises: Array<Promise<unknown>>): CommanderThunkAction<AsyncAction<Array<unknown>>> =>
    async (dispatch) => {
        const promise = Promise.all(promises);

        return dispatch(createAction(INIT, { promise }));
    };
